module.exports = __webpack_public_path__ + "static/media/icono1.7aa28e83.png";